/**
 * Brand Switcher (Dawn)
 *
 * IMPORTANT BEHAVIOR: the switcher never re-skins the current page into
 * a different brand. Every page belongs to exactly one brand (Maine
 * Beach is the site default/homepage; Beltana and Sorce pages are
 * detected by URL, see snippets/brand-detect.liquid), and every button
 * in the switcher is a plain link to that brand's own home page --
 * clicking a different brand always navigates away, it never swaps
 * colors/logo/menu in place. This was a deliberate correction: an
 * earlier version let a manual click re-skin the current page's header
 * without navigating, which incorrectly let Beltana's theming appear
 * overlaid on Maine Beach/Sorce content.
 *
 * What JS still does here, all just for the CURRENT page's already-
 * correct server-detected brand (not for switching):
 *  - Highlights which button is "active" in the switcher UI.
 *  - Syncs the footer's color scheme to match the header's (the footer
 *    can't read the header's brand blocks directly server-side, since
 *    Shopify sections can't access each other's blocks -- this is a
 *    read-only sync on load, not a response to clicking).
 *  - Shows the correct brand's logo/menu instances (still rendered per
 *    brand in the page, since Dawn's blocks make that reliable to do
 *    server-side, but this is what actually shows the right one).
 */
(function () {
  var root = document.documentElement;

  function getBrandData() {
    var el = document.getElementById('brand-switcher-data');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  var BRANDS = getBrandData();

  function findBrand(handle) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i].handle === handle) return BRANDS[i];
    }
    return null;
  }

  function updateButtonStates() {
    var current = root.getAttribute('data-brand');
    document
      .querySelectorAll('[data-brand-switcher] .brand-switcher__btn')
      .forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-brand') === current);
      });
  }

  function syncFooterColors() {
    var brand = findBrand(root.getAttribute('data-brand'));
    if (!brand) return;

    var schemeClass = 'color-' + (brand.scheme || 'scheme-1');
    var footer = document.querySelector('.footer');
    if (!footer) return;

    // The header's own scheme is already correct from server-side
    // rendering; this just brings the footer (a separate section that
    // can't read the header's brand blocks) into sync with it, once,
    // on page load.
    footer.className = footer.className.replace(/\bcolor-scheme-\d+\b/g, '').trim();
    footer.classList.add(schemeClass);
  }

  function updateLogoVisibility() {
    var current = root.getAttribute('data-brand');
    document.querySelectorAll('.brand-logo').forEach(function (el) {
      el.style.display = el.getAttribute('data-brand-logo') === current ? 'inline-block' : 'none';
    });
  }

  function updateMenuVisibility() {
    var current = root.getAttribute('data-brand');
    document.querySelectorAll('[data-brand-menu]').forEach(function (el) {
      if (el.getAttribute('data-brand-menu') === current) {
        el.style.removeProperty('display');
      } else {
        el.style.display = 'none';
      }
    });
  }

  function init() {
    updateButtonStates();
    syncFooterColors();
    updateLogoVisibility();
    updateMenuVisibility();
    // No click handler here on purpose -- the switcher buttons are
    // plain <a href="..."> links to each brand's home page, and are
    // left to navigate normally.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
